// modules
import { createSelector } from 'reselect'
import { get, sortBy } from 'lodash'

// utils
import { patientSelector } from 'src/store/modules/patient/selectors'

const patientMedicalDevices$ = createSelector(patientSelector, (profile) =>
  get(profile, ['medicalDevices'], [])
)

export const patientMedicalDeviceOrderingList$ = createSelector(
  patientMedicalDevices$,
  (medicalDevices = {}) => get(medicalDevices, ['orderList'], [])
)

export const patientMedicalDeviceOrderingTypeList$ = createSelector(
  patientMedicalDevices$,
  (medicalDevices = {}) => get(medicalDevices, ['medicalDeviceTypeList'], [])
)

export const patientMedicalDeviceOrderingEditOrder$ = createSelector(
  patientMedicalDevices$,
  (medicalDevices = {}) => get(medicalDevices, ['editOrder'], {})
)

export const patientMedicalDeviceOrderingTypeListDropdown$ = createSelector(
  patientMedicalDeviceOrderingTypeList$,
  (medicalDeviceTypes = []) =>
    sortBy(
      medicalDeviceTypes.map((item) => ({
        key: item.uuid,
        title: item.name,
        value: item.uuid,
        isActive: item.isActive,
        disabled: !item.isActive,
        isIntegrationIdRequired: item.isIntegrationIdRequired
      })),
      'orderNumber'
    )
)
